import React from "react"
import { Link } from "gatsby"
import SideBarMenu from "../sidebar/sidebar"
import Sticky from "react-sticky-el"
import { stickyWrapper, isSticky, header } from "./header.module.css"
// import logo from "../../images/logo.png"
import { StaticImage } from "gatsby-plugin-image"

const Header = () => (
  <header>
    <Sticky
      className={stickyWrapper}
      stickyClassName={isSticky}
      stickyStyle={{ transform: "unset", zIndex: "2" }}
    >
      <div id="header-t" className="header-top">
        <div className="container">
          <div className="row">
            <div className="col">
              <div className="header-top-content d-flex justify-content-end align-items-center">
                <div className="header-phone d-flex align-content-center justify-content-sm-start mr-4">
                  <i className="fa fa-phone mr-2" />
                  <a title="contact" href="tel:(303)814-2688">
                    (303)814-2688
                  </a>
                </div>
                <div className="header-mail d-flex align-content-center justify-content-sm-start">
                  <i className="fa fa-envelope mr-2" />
                  <a title="email" href="mailto:francis@assuredal.com">
                    francis@assuredal.com
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={`header ${header}`}>
        <div className="container">
          <div className="row justify-content-between align-items-center">
            <div className="col">
              <div className="header-logo">
                <Link title="logo" to="/">
                  <span className="display-4 text-white">
                    <StaticImage
                      src="../../images/logo.png"
                      // placeholder="blurred"
                      width={200}
                      // layout="constrained"
                      alt="Logo"
                      style={{ marginBottom: "unset" }}
                    />
                  </span>
                </Link>
              </div>
            </div>
            <div className="col-4">
              <div className="text-right">
                <SideBarMenu />
              </div>
            </div>
          </div>
        </div>
      </div>
    </Sticky>
  </header>
)

export default Header
